function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
};

var CompletedFinished = function (_Component) {
  inherits(CompletedFinished, _Component);

  function CompletedFinished() {
    classCallCheck(this, CompletedFinished);
    return possibleConstructorReturn(this, (CompletedFinished.__proto__ || Object.getPrototypeOf(CompletedFinished)).apply(this, arguments));
  }

  createClass(CompletedFinished, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          testsCompleted = _props.testsCompleted,
          testsTotal = _props.testsTotal,
          status = _props.status;
      return /*#__PURE__*/React.createElement('span', {
        className: 'text-center'
      }, /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-check mr-1'
      }), 'Completados ', testsCompleted, ' de ', testsTotal, /*#__PURE__*/React.createElement('small', {
        className: 'd-block text-muted'
      }, status));
    }
  }]);
  return CompletedFinished;
}(Component);

var CompletedProgress = function (_Component) {
  inherits(CompletedProgress, _Component);

  function CompletedProgress() {
    classCallCheck(this, CompletedProgress);
    return possibleConstructorReturn(this, (CompletedProgress.__proto__ || Object.getPrototypeOf(CompletedProgress)).apply(this, arguments));
  }

  createClass(CompletedProgress, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          testsCompleted = _props.testsCompleted,
          testsTotal = _props.testsTotal,
          status = _props.status;
      return /*#__PURE__*/React.createElement('span', {
        className: 'text-center'
      }, /*#__PURE__*/React.createElement('i', {
        className: 'far fa-clock  mr-1'
      }), 'Completados ', testsCompleted, ' de ', testsTotal, /*#__PURE__*/React.createElement('small', {
        className: 'd-block text-muted'
      }, status));
    }
  }]);
  return CompletedProgress;
}(Component);

// Dependencies
var CompletedInfo = function (_Component) {
  inherits(CompletedInfo, _Component);

  function CompletedInfo() {
    classCallCheck(this, CompletedInfo);
    return possibleConstructorReturn(this, (CompletedInfo.__proto__ || Object.getPrototypeOf(CompletedInfo)).apply(this, arguments));
  }

  createClass(CompletedInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          testsCompleted = _props.testsCompleted,
          testsTotal = _props.testsTotal,
          status = _props.status;

      if (testsCompleted === testsTotal) {
        return /*#__PURE__*/React.createElement(CompletedFinished, {
          testsCompleted: testsCompleted,
          testsTotal: testsTotal,
          status: status
        });
      }

      return /*#__PURE__*/React.createElement(CompletedProgress, {
        testsCompleted: testsCompleted,
        testsTotal: testsTotal,
        status: status
      });
    }
  }]);
  return CompletedInfo;
}(Component);

// Dependencies
var ProfileInfo = function (_Component) {
  inherits(ProfileInfo, _Component);

  function ProfileInfo() {
    classCallCheck(this, ProfileInfo);
    return possibleConstructorReturn(this, (ProfileInfo.__proto__ || Object.getPrototypeOf(ProfileInfo)).apply(this, arguments));
  }

  createClass(ProfileInfo, [{
    key: 'render',
    value: function render() {
      var profileName = this.props.profileName;
      return /*#__PURE__*/React.createElement('div', {
        className: 'col-md-2 col-6 text-right'
      }, /*#__PURE__*/React.createElement('span', {
        className: 'badge rounded-lg total-score text-center p-3 my-2 mx-auto text-wrap badge-light border border-primary text-primary'
      }, /*#__PURE__*/React.createElement('p', {
        className: 'mb-0'
      }, 'Perfil'), /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-user fa-3x my-2 d-block'
      }), /*#__PURE__*/React.createElement('small', null, profileName)));
    }
  }]);
  return ProfileInfo;
}(Component);

// Dependencies
var ProfileUnknown = function (_Component) {
  inherits(ProfileUnknown, _Component);

  function ProfileUnknown() {
    classCallCheck(this, ProfileUnknown);
    return possibleConstructorReturn(this, (ProfileUnknown.__proto__ || Object.getPrototypeOf(ProfileUnknown)).apply(this, arguments));
  }

  createClass(ProfileUnknown, [{
    key: 'render',
    value: function render() {
      return /*#__PURE__*/React.createElement('div', {
        className: 'col-md-2 col-6 text-right'
      }, /*#__PURE__*/React.createElement('span', {
        className: 'badge rounded-lg total-score text-center p-3 my-2 mx-auto text-wrap badge-light border border-dark text-muted'
      }, /*#__PURE__*/React.createElement('p', {
        className: 'mb-0'
      }, 'Perfil'), /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-user fa-3x my-2 d-block'
      }), /*#__PURE__*/React.createElement('small', null, 'No hay Perfil asociado')));
    }
  }]);
  return ProfileUnknown;
}(Component); // Dependencies


var Profile = function (_Component) {
  inherits(Profile, _Component);

  function Profile() {
    classCallCheck(this, Profile);
    return possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  createClass(Profile, [{
    key: 'render',
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _props = this.props,
          profileName = _props.profileName,
          profileId = _props.profileId;

      if (profileId) {
        return /*#__PURE__*/React.createElement(ProfileInfo, {
          profileName: profileName
        });
      }

      return /*#__PURE__*/React.createElement(ProfileUnknown, null);
    }
  }]);
  return Profile;
}(Component); // Dependencies


var Header = function (_Component) {
  inherits(Header, _Component);

  function Header() {
    classCallCheck(this, Header);
    return possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  createClass(Header, [{
    key: 'render',
    value: function render() {
      var mainData = this.props.mainData;
      return /*#__PURE__*/React.createElement('div', {
        className: 'd-flex align-items-center justify-content-around text-bold m-4'
      }, /*#__PURE__*/React.createElement('span', {
        className: 'text-center'
      }, /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-medal mr-1'
      }), 'Puntaje Zyvo:', /*#__PURE__*/React.createElement('strong', {
        className: 'ml-1'
      }, mainData.main_score, '%'), /*#__PURE__*/React.createElement('small', {
        className: 'd-block text-muted'
      }, 'Coincidencia con el perfil buscado')), mainData.profile_name ? /*#__PURE__*/React.createElement('span', {
        className: 'text-center'
      }, /*#__PURE__*/React.createElement('i', {
        className: 'far fa-id-card mr-1'
      }), mainData.profile_name, /*#__PURE__*/React.createElement('small', {
        className: 'd-block text-muted'
      }, 'Puntuaci\xF3n en base a este perfil')) : null, /*#__PURE__*/React.createElement(CompletedInfo, {
        testsCompleted: mainData.count_rendered,
        testsTotal: mainData.count_total,
        status: mainData.es_status
      }));
    }
  }]);
  return Header;
}(Component);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';

var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();

var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}

var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}

function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}

function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}

function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}

function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(_abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (_abstract.attributes && (_abstract.attributes.fill || force)) {
    _abstract.attributes.fill = 'black';
  }

  return _abstract;
}

function deGroup(_abstract2) {
  if (_abstract2.tag === 'g') {
    return _abstract2.children;
  } else {
    return [_abstract2];
  }
}

function makeIconMasking(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(nextUniqueId());
  var clipId = "clip-".concat(nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard(_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon(_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol(_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var widthClass = "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    transform: transform,
    symbol: symbol,
    styles: extra.styles
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};

var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = ('far' in styles);
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};

build();
var styles$1 = namespace.styles;

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}

MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;
var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};
var styles$2 = namespace.styles;

function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}

var styles$3 = namespace.styles;
var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val["abstract"].map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

function _typeof$2(obj) {
  if (typeof Symbol === "function" && _typeof(Symbol.iterator) === "symbol") {
    _typeof$2 = function _typeof$2(obj) {
      return _typeof(obj);
    };
  } else {
    _typeof$2 = function _typeof$2(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof(obj);
    };
  }

  return _typeof$2(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
} // Get CSS class list from a props object


function classList(props) {
  var _classes;

  var spin = props.spin,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty$1(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty$1(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null), _defineProperty$1(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty$1(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
} // Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number


function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, ["style"]);

  mixins.attrs['style'] = _objectSpread$1({}, mixins.attrs['style'], existingStyle);
  return createElement.apply(void 0, [element.tag, _objectSpread$1({}, mixins.attrs, remaining)].concat(_toConsumableArray$1(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = process.env.NODE_ENV === 'production';
} catch (e) {}

function log() {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
} // Normalize icon arguments


function normalizeIconArgs(icon$$1) {
  // if the icon is null, there's nothing to do
  if (icon$$1 === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (_typeof$2(icon$$1) === 'object' && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  } // if it's an array with length of two


  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon$$1[0],
      iconName: icon$$1[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon$$1 === 'string') {
    return {
      prefix: 'fas',
      iconName: icon$$1
    };
  }
} // creates an object with a key of key
// and a value of value
// if certain conditions are met


function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$1({}, key, value) : {};
}

function FontAwesomeIcon(props) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray$1(classList(props)), _toConsumableArray$1(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread$1({}, classes, transform, mask, {
    symbol: symbol,
    title: title
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var _abstract3 = renderedIcon["abstract"];
  var extraProps = {};
  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(_abstract3[0], extraProps);
}

FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: PropTypes.bool,
  className: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(['right', 'left']),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([90, 180, 270]),
  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React.createElement);
var faAtom = {
  prefix: 'fas',
  iconName: 'atom',
  icon: [448, 512, [], "f5d2", "M413.03 256c40.13-54.89 41.51-98.62 25.14-128-10.91-19.52-40.54-50.73-116.33-41.88C300.36 34.89 267.64 0 224 0s-76.36 34.89-97.84 86.12C50.43 77.34 20.73 108.48 9.83 128c-16.38 29.4-15 73.09 25.14 128-40.13 54.89-41.51 98.62-25.14 128 29.21 52.34 101.68 43.58 116.33 41.88C147.63 477.1 180.36 512 224 512s76.37-34.9 97.84-86.12c14.64 1.7 87.11 10.46 116.33-41.88 16.38-29.4 15-73.09-25.14-128zM63.38 352c-4.03-7.21-.19-24.8 14.95-48.29 6.96 6.53 14.2 12.89 21.87 19.18 1.71 13.71 4 27.08 6.76 40.08-24.56.89-39.89-4.37-43.58-10.97zm36.82-162.88c-7.66 6.29-14.9 12.65-21.87 19.18-15.13-23.5-18.97-41.09-14.95-48.3 3.41-6.14 16.39-11.47 37.92-11.47 1.71 0 3.87.3 5.69.37a472.191 472.191 0 0 0-6.79 40.22zM224 64c9.47 0 22.2 13.52 33.86 37.26-11.19 3.7-22.44 8-33.86 12.86-11.42-4.86-22.67-9.16-33.86-12.86C201.8 77.52 214.53 64 224 64zm0 384c-9.47 0-22.2-13.52-33.86-37.26 11.19-3.7 22.44-8 33.86-12.86 11.42 4.86 22.67 9.16 33.86 12.86C246.2 434.48 233.47 448 224 448zm62.5-157.33c-26.7 19.08-46.14 29.33-62.5 37.48-16.35-8.14-35.8-18.41-62.5-37.48-1.99-27.79-1.99-41.54 0-69.33 26.67-19.05 46.13-29.32 62.5-37.48 16.39 8.17 35.86 18.44 62.5 37.48 1.98 27.78 1.99 41.53 0 69.33zM384.62 352c-3.67 6.62-19 11.82-43.58 10.95 2.76-13 5.05-26.37 6.76-40.06 7.66-6.29 14.9-12.65 21.87-19.18 15.13 23.49 18.97 41.08 14.95 48.29zm-14.95-143.71c-6.96-6.53-14.2-12.89-21.87-19.18a473.535 473.535 0 0 0-6.79-40.22c1.82-.07 3.97-.37 5.69-.37 21.52 0 34.51 5.34 37.92 11.47 4.02 7.22.18 24.81-14.95 48.3zM224 224c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"]
};
var faBrain = {
  prefix: 'fas',
  iconName: 'brain',
  icon: [576, 512, [], "f5dc", "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"]
}; // Dependencies

var CognitiveTitle = function (_Component) {
  inherits(CognitiveTitle, _Component);

  function CognitiveTitle(props) {
    classCallCheck(this, CognitiveTitle);

    var _this = possibleConstructorReturn(this, (CognitiveTitle.__proto__ || Object.getPrototypeOf(CognitiveTitle)).call(this, props));

    _this.state = {
      isToggleOn: true
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  createClass(CognitiveTitle, [{
    key: 'handleClick',
    value: function handleClick() {
      this.setState(function (state) {
        return {
          isToggleOn: !state.isToggleOn
        };
      });
    }
  }, {
    key: 'drawInfoText',
    value: function drawInfoText() {
      return this.state.isToggleOn ? 'ver más' : 'ver menos';
    }
  }, {
    key: 'drawCoincidenceText',
    value: function drawCoincidenceText() {
      return this.props.hasProfile ? 'Coincidencia con el Perfil: ' : 'Puntaje: ';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          description = _props.description,
          score = _props.score,
          testsCompleted = _props.testsCompleted,
          testsTotal = _props.testsTotal,
          enrollment = _props.enrollment;
      var iconBrain = /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faBrain
      });
      return /*#__PURE__*/React.createElement('div', {
        className: 'card-header bg-white'
      }, /*#__PURE__*/React.createElement('div', {
        className: 'd-flex justify-content-between align-items-center'
      }, /*#__PURE__*/React.createElement('div', {
        className: 'd-flex align-items-center'
      }, /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-pull-left h5 mb-0'
      }, iconBrain), /*#__PURE__*/React.createElement('h3', {
        className: 'h5 mb-0 d-inline-block'
      }, title)), /*#__PURE__*/React.createElement('div', {
        className: 'text-info'
      }, /*#__PURE__*/React.createElement(CompletedInfo, {
        testsCompleted: testsCompleted,
        testsTotal: testsTotal
      }))), /*#__PURE__*/React.createElement('div', {
        className: 'small text-muted text-justify py-4'
      }, description), /*#__PURE__*/React.createElement('div', {
        className: 'd-flex justify-content-between align-items-center'
      }, /*#__PURE__*/React.createElement('span', {
        className: 'badge badge-pill badge-primary',
        'data-placement': 'bottom',
        'data-toggle': 'tooltip',
        title: 'Coincidencia - Puntaje Cognitivo',
        'data-original-title': 'Coincidencia - Puntaje Cognitivo'
      }, this.drawCoincidenceText(), score, '%'), /*#__PURE__*/React.createElement('small', {
        onClick: this.handleClick,
        className: 'text-primary pointer',
        'data-toggle': 'collapse',
        'data-target': '#cognitive_' + enrollment + '_toggler',
        'aria-expanded': 'false',
        'aria-controls': 'cognitive_' + enrollment + '_toggler'
      }, this.drawInfoText())));
    }
  }]);
  return CognitiveTitle;
}(Component);

// Dependencies
var ScoreTitle = function (_Component) {
  inherits(ScoreTitle, _Component);

  function ScoreTitle() {
    classCallCheck(this, ScoreTitle);
    return possibleConstructorReturn(this, (ScoreTitle.__proto__ || Object.getPrototypeOf(ScoreTitle)).apply(this, arguments));
  }

  createClass(ScoreTitle, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          name = _props.name,
          description = _props.description,
          tooltip = _props.tooltip;
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-between align-items-center my-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "d-block"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "text-capitalize h6 mb-0"
      }, name), /*#__PURE__*/React.createElement("small", {
        className: "text-muted d-block text-justify"
      }, description)), /*#__PURE__*/React.createElement("span", {
        className: "btn text-muted",
        "data-placement": "top",
        "data-toggle": "tooltip",
        "data-original-title": tooltip
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-info-circle"
      })));
    }
  }]);
  return ScoreTitle;
}(Component);

// Dependencies
var ProfileScore = function (_Component) {
  inherits(ProfileScore, _Component);

  function ProfileScore() {
    classCallCheck(this, ProfileScore);
    return possibleConstructorReturn(this, (ProfileScore.__proto__ || Object.getPrototypeOf(ProfileScore)).apply(this, arguments));
  }

  createClass(ProfileScore, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          score = _props.score,
          tooltipMessage = _props.tooltipMessage,
          icon = _props.icon;

      var _roundedScore = Math.round(score);

      var message = tooltipMessage + ": " + _roundedScore + "%";
      return /*#__PURE__*/React.createElement("div", {
        className: "indicator",
        style: {
          left: _roundedScore + "%"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "btn _btn-circle _btn-circle-sm m-1",
        "data-placement": "top",
        "data-toggle": "tooltip",
        "data-original-title": "" + message
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas " + icon + " fa-uxs text-primary mt-1"
      })));
    }
  }]);
  return ProfileScore;
}(Component);

// Dependencies
var FavoriteProfileScore = function (_Component) {
  inherits(FavoriteProfileScore, _Component);

  function FavoriteProfileScore() {
    classCallCheck(this, FavoriteProfileScore);
    return possibleConstructorReturn(this, (FavoriteProfileScore.__proto__ || Object.getPrototypeOf(FavoriteProfileScore)).apply(this, arguments));
  }

  createClass(FavoriteProfileScore, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          profiledScore = _props.profiledScore,
          optimalScore = _props.optimalScore;
      var optimalScoreRounded = Math.round(optimalScore);
      var profiledScoreRounded = Math.round(profiledScore);
      var average = (optimalScoreRounded + profiledScoreRounded) / 2;
      var message = '<strong class="text-primary">Puntaje Logrado:</strong>\n                    ' + profiledScoreRounded + '% <br/>\n                    <strong class="text-info">Puntaje \xD3ptimo:</strong>\n                    ' + optimalScoreRounded + '%';
      return /*#__PURE__*/React.createElement('div', {
        className: 'indicator',
        style: {
          left: average + '%'
        }
      }, /*#__PURE__*/React.createElement('span', {
        className: 'btn _btn-circle _btn-circle-sm m-1',
        'data-placement': 'top',
        'data-toggle': 'tooltip',
        'data-html': 'true',
        'data-original-title': message
      }, /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-heart fa-uxs text-primary mt-1'
      })));
    }
  }]);
  return FavoriteProfileScore;
}(Component);

// Dependencies
var ScoreCompleted = function (_Component) {
  inherits(ScoreCompleted, _Component);

  function ScoreCompleted() {
    classCallCheck(this, ScoreCompleted);
    return possibleConstructorReturn(this, (ScoreCompleted.__proto__ || Object.getPrototypeOf(ScoreCompleted)).apply(this, arguments));
  }

  createClass(ScoreCompleted, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          score = _props.score,
          lowLevel = _props.lowLevel,
          highLevel = _props.highLevel;
      var _props2 = this.props,
          profiledScore = _props2.profiledScore,
          optimalScore = _props2.optimalScore;
      var roundedScore = Math.round(score);
      var differenceScore = Math.abs(optimalScore - profiledScore);

      if (optimalScore && profiledScore && differenceScore <= 5) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "d-block relative-item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "range",
          disabled: true,
          readOnly: true,
          className: "custom-range without_slider"
        }), /*#__PURE__*/React.createElement(FavoriteProfileScore, {
          profiledScore: profiledScore,
          optimalScore: optimalScore
        })), /*#__PURE__*/React.createElement("div", {
          className: "row text-primary"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-sm-6 text-left"
        }, /*#__PURE__*/React.createElement("small", null, lowLevel)), /*#__PURE__*/React.createElement("div", {
          className: "col-sm-6 text-right"
        }, /*#__PURE__*/React.createElement("small", null, highLevel))));
      }

      if (optimalScore && profiledScore) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "d-block relative-item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "range",
          disabled: true,
          readOnly: true,
          className: "custom-range without_slider"
        }), /*#__PURE__*/React.createElement(ProfileScore, {
          score: profiledScore,
          tooltipMessage: "Puntaje Logrado",
          icon: "fa-user"
        }), /*#__PURE__*/React.createElement(ProfileScore, {
          score: optimalScore,
          tooltipMessage: "Puntaje \xD3ptimo",
          icon: "fa-star"
        })), /*#__PURE__*/React.createElement("div", {
          className: "row text-primary"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-sm-6 text-left"
        }, /*#__PURE__*/React.createElement("small", null, lowLevel)), /*#__PURE__*/React.createElement("div", {
          className: "col-sm-6 text-right"
        }, /*#__PURE__*/React.createElement("small", null, highLevel))));
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "d-block relative-item"
      }, /*#__PURE__*/React.createElement("input", {
        type: "range",
        disabled: true,
        readOnly: true,
        className: "custom-range without_slider"
      }), /*#__PURE__*/React.createElement(ProfileScore, {
        score: roundedScore,
        tooltipMessage: "Puntaje Logrado",
        icon: "fa-user"
      })), /*#__PURE__*/React.createElement("div", {
        className: "row text-primary"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 text-left"
      }, /*#__PURE__*/React.createElement("small", null, lowLevel)), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 text-right"
      }, /*#__PURE__*/React.createElement("small", null, highLevel))));
    }
  }]);
  return ScoreCompleted;
}(Component);

// Dependencies
var ScoreAwaiting = function (_Component) {
  inherits(ScoreAwaiting, _Component);

  function ScoreAwaiting() {
    classCallCheck(this, ScoreAwaiting);
    return possibleConstructorReturn(this, (ScoreAwaiting.__proto__ || Object.getPrototypeOf(ScoreAwaiting)).apply(this, arguments));
  }

  createClass(ScoreAwaiting, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("small", {
        className: "text-info"
      }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-spinner fa-pulse mr-1"
      }), "\xA0En espera de resultados:"), "\xA0", /*#__PURE__*/React.createElement("span", null, "El candidato no ha rendido esta evaluaci\xF3n"));
    }
  }]);
  return ScoreAwaiting;
}(Component); // Dependencies


var ScoreBar = function (_Component) {
  inherits(ScoreBar, _Component);

  function ScoreBar() {
    classCallCheck(this, ScoreBar);
    return possibleConstructorReturn(this, (ScoreBar.__proto__ || Object.getPrototypeOf(ScoreBar)).apply(this, arguments));
  }

  createClass(ScoreBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          score = _props.score,
          lowLevel = _props.lowLevel,
          highLevel = _props.highLevel; // eslint-disable-next-line react/prop-types

      var _props2 = this.props,
          profiledScore = _props2.profiledScore,
          optimalScore = _props2.optimalScore;

      if (!score) {
        return /*#__PURE__*/React.createElement(ScoreAwaiting, null);
      }

      return /*#__PURE__*/React.createElement(ScoreCompleted, {
        score: score,
        lowLevel: lowLevel,
        highLevel: highLevel,
        profiledScore: profiledScore,
        optimalScore: optimalScore
      });
    }
  }]);
  return ScoreBar;
}(Component);

// Dependencies
var Score = function (_Component) {
  inherits(Score, _Component);

  function Score() {
    classCallCheck(this, Score);
    return possibleConstructorReturn(this, (Score.__proto__ || Object.getPrototypeOf(Score)).apply(this, arguments));
  }

  createClass(Score, [{
    key: "render",
    value: function render() {
      var score = this.props.score;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement(ScoreTitle, {
        name: score.es_name,
        description: score.es_description,
        tooltip: score.es_tooltip
      }), /*#__PURE__*/React.createElement(ScoreBar, {
        score: score.score,
        lowLevel: score.es_low_level,
        highLevel: score.es_high_level,
        profiledScore: score.profiled_score,
        optimalScore: score.optimal_score
      }), /*#__PURE__*/React.createElement("hr", null));
    }
  }]);
  return Score;
}(Component);

var CognitiveCompetencies = function (_Component) {
  inherits(CognitiveCompetencies, _Component);

  function CognitiveCompetencies() {
    classCallCheck(this, CognitiveCompetencies);
    return possibleConstructorReturn(this, (CognitiveCompetencies.__proto__ || Object.getPrototypeOf(CognitiveCompetencies)).apply(this, arguments));
  }

  createClass(CognitiveCompetencies, [{
    key: "render",
    value: function render() {
      var scores = this.props.scores;
      return /*#__PURE__*/React.createElement("div", {
        className: "card-body row"
      }, scores.map(function (score) {
        return /*#__PURE__*/React.createElement(Score, {
          score: score,
          key: score.id
        });
      }));
    }
  }]);
  return CognitiveCompetencies;
}(Component);

// Dependencies
var CognitiveCard = function (_Component) {
  inherits(CognitiveCard, _Component);

  function CognitiveCard() {
    classCallCheck(this, CognitiveCard);
    return possibleConstructorReturn(this, (CognitiveCard.__proto__ || Object.getPrototypeOf(CognitiveCard)).apply(this, arguments));
  }

  createClass(CognitiveCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cognitiveDataMain = _props.cognitiveDataMain,
          cognitiveDataScores = _props.cognitiveDataScores,
          hasProfile = _props.hasProfile,
          enrollment = _props.enrollment;
      return /*#__PURE__*/React.createElement('div', {
        className: 'card card-hover mb-4'
      }, /*#__PURE__*/React.createElement(CognitiveTitle, {
        title: cognitiveDataMain.title,
        description: cognitiveDataMain.description,
        score: cognitiveDataMain.cognitive_score,
        testsCompleted: cognitiveDataMain.count_rendered,
        testsTotal: cognitiveDataMain.count_total,
        hasProfile: hasProfile,
        enrollment: enrollment
      }), /*#__PURE__*/React.createElement('div', {
        className: 'collapse',
        id: 'cognitive_' + enrollment + '_toggler'
      }, /*#__PURE__*/React.createElement(CognitiveCompetencies, {
        scores: cognitiveDataScores
      })));
    }
  }]);
  return CognitiveCard;
}(Component);

var PersonalityTitle = function (_Component) {
  inherits(PersonalityTitle, _Component);

  function PersonalityTitle(props) {
    classCallCheck(this, PersonalityTitle);

    var _this = possibleConstructorReturn(this, (PersonalityTitle.__proto__ || Object.getPrototypeOf(PersonalityTitle)).call(this, props));

    _this.state = {
      isToggleOn: true
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  createClass(PersonalityTitle, [{
    key: 'handleClick',
    value: function handleClick() {
      this.setState(function (state) {
        return {
          isToggleOn: !state.isToggleOn
        };
      });
    }
  }, {
    key: 'drawInfoText',
    value: function drawInfoText() {
      return this.state.isToggleOn ? 'ver más' : 'ver menos';
    }
  }, {
    key: 'drawCoincidenceText',
    value: function drawCoincidenceText() {
      return this.props.hasProfile ? 'Coincidencia con el Perfil: ' : 'Puntaje: ';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          description = _props.description,
          score = _props.score,
          testsCompleted = _props.testsCompleted,
          testsTotal = _props.testsTotal,
          enrollment = _props.enrollment;
      var iconAtom = /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faAtom
      });
      return /*#__PURE__*/React.createElement('div', {
        className: 'card-header bg-white'
      }, /*#__PURE__*/React.createElement('div', {
        className: 'd-flex justify-content-between align-items-center'
      }, /*#__PURE__*/React.createElement('div', {
        className: 'd-flex align-items-center'
      }, /*#__PURE__*/React.createElement('i', {
        className: 'fas fa-pull-left h5 mb-0'
      }, iconAtom), /*#__PURE__*/React.createElement('h3', {
        className: 'h5 mb-0 d-inline-block'
      }, title)), /*#__PURE__*/React.createElement('div', {
        className: 'text-info'
      }, /*#__PURE__*/React.createElement(CompletedInfo, {
        testsCompleted: testsCompleted,
        testsTotal: testsTotal
      }))), /*#__PURE__*/React.createElement('div', {
        className: 'small text-muted text-justify py-3'
      }, description), /*#__PURE__*/React.createElement('div', {
        className: 'd-flex justify-content-between align-items-center'
      }, /*#__PURE__*/React.createElement('span', {
        className: 'badge badge-pill badge-primary',
        'data-placement': 'bottom',
        'data-toggle': 'tooltip',
        title: 'Coincidencia - Puntaje Cognitivo',
        'data-original-title': 'Coincidencia - Puntaje Cognitivo'
      }, this.drawCoincidenceText(), score, '%'), /*#__PURE__*/React.createElement('small', {
        onClick: this.handleClick,
        className: 'text-primary pointer',
        'data-toggle': 'collapse',
        'data-target': '#personality_' + enrollment + '_toggler',
        'aria-expanded': 'false',
        'aria-controls': '#personality_' + enrollment + '_toggler'
      }, this.drawInfoText())));
    }
  }]);
  return PersonalityTitle;
}(Component);

var PersonalityCompetencies = function (_Component) {
  inherits(PersonalityCompetencies, _Component);

  function PersonalityCompetencies() {
    classCallCheck(this, PersonalityCompetencies);
    return possibleConstructorReturn(this, (PersonalityCompetencies.__proto__ || Object.getPrototypeOf(PersonalityCompetencies)).apply(this, arguments));
  }

  createClass(PersonalityCompetencies, [{
    key: "render",
    value: function render() {
      var scores = this.props.scores;
      return /*#__PURE__*/React.createElement("div", {
        className: "card-body row"
      }, scores.map(function (score) {
        return /*#__PURE__*/React.createElement(Score, {
          score: score,
          key: score.id
        });
      }));
    }
  }]);
  return PersonalityCompetencies;
}(Component);

// Dependencies
var PersonalityCard = function (_Component) {
  inherits(PersonalityCard, _Component);

  function PersonalityCard() {
    classCallCheck(this, PersonalityCard);
    return possibleConstructorReturn(this, (PersonalityCard.__proto__ || Object.getPrototypeOf(PersonalityCard)).apply(this, arguments));
  }

  createClass(PersonalityCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          personalityDataMain = _props.personalityDataMain,
          personalityDataScores = _props.personalityDataScores,
          hasProfile = _props.hasProfile,
          enrollment = _props.enrollment;
      return /*#__PURE__*/React.createElement('div', {
        className: 'card card-hover mb-4'
      }, /*#__PURE__*/React.createElement(PersonalityTitle, {
        title: personalityDataMain.title,
        description: personalityDataMain.description,
        score: personalityDataMain.personality_score,
        testsCompleted: personalityDataMain.count_rendered,
        testsTotal: personalityDataMain.count_total,
        hasProfile: hasProfile,
        enrollment: enrollment
      }), /*#__PURE__*/React.createElement('div', {
        className: 'collapse',
        id: 'personality_' + enrollment + '_toggler'
      }, /*#__PURE__*/React.createElement(PersonalityCompetencies, {
        scores: personalityDataScores
      })));
    }
  }]);
  return PersonalityCard;
}(Component);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css$1 = ".progress-bar {\n  width: 0;\n  animation: progress 1.5s ease-in-out forwards; }\n  .progress-bar span {\n    opacity: 0;\n    animation: show 0.35s forwards ease-in-out 0.5s; }\n\n.text-shadow {\n  text-shadow: 1px 1px 0px #333; }\n\n.big-badge {\n  width: 100px; }\n\n.total-score {\n  width: 90px; }\n\n@keyframes progress {\n  from {\n    width: 0; }\n  to {\n    width: 100%; } }\n\n@keyframes show {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.relative-item {\n  position: relative; }\n\n.indicator {\n  position: absolute;\n  z-index: 5;\n  height: 26px;\n  top: -4px; }\n  .indicator .btn {\n    position: absolute;\n    right: -12px;\n    line-height: 0;\n    font-size: 25px;\n    text-shadow: 1px 1px 1px #fff;\n    color: #5a3ee0;\n    background-color: #fff;\n    border-radius: 50%; }\n\n@media (min-width: 768px) {\n  .cognitive-results .list-group {\n    border: 0; }\n    .cognitive-results .list-group .list-group-item:nth-child(odd) {\n      border-right: 1px solid rgba(0, 0, 0, 0.125);\n      border-bottom: 1px solid rgba(0, 0, 0, 0.125); }\n    .cognitive-results .list-group .list-group-item:nth-child(2) {\n      border-top: none; }\n    .cognitive-results .list-group .list-group-item:last-child {\n      border-bottom: none; } }\n\n.fa-uxs {\n  font-size: 0.5em; }\n\n._btn-circle {\n  width: 45px;\n  height: 45px;\n  line-height: 45px;\n  text-align: center;\n  padding: 0;\n  border-radius: 50%; }\n\n._btn-circle i {\n  position: relative;\n  top: -1px; }\n\n._btn-circle-sm {\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  font-size: 0.9rem; }\n\n.without_slider::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  appearance: none !important;\n  background: none !important; }\n\n.without_slider::-moz-range-thumb {\n  -webkit-appearance: none !important;\n  appearance: none !important;\n  background: none !important; }\n";
styleInject(css$1); // Dependencies
// import scores from '../src/scores/enrollment'

var EnrollmentScores = function (_Component) {
  inherits(EnrollmentScores, _Component);

  function EnrollmentScores() {
    classCallCheck(this, EnrollmentScores);
    return possibleConstructorReturn(this, (EnrollmentScores.__proto__ || Object.getPrototypeOf(EnrollmentScores)).apply(this, arguments));
  }

  createClass(EnrollmentScores, [{
    key: 'render',
    value: function render() {
      var scores = this.props.scores;
      var _scores$main_data = scores.main_data,
          enrollment_id = _scores$main_data.enrollment_id,
          profile_id = _scores$main_data.profile_id;
      return /*#__PURE__*/React.createElement('div', {
        className: 'container'
      }, /*#__PURE__*/React.createElement(Header, {
        mainData: scores.main_data
      }), /*#__PURE__*/React.createElement('div', {
        className: 'row'
      }, scores.cognitive_data.scores.length > 0 ? /*#__PURE__*/React.createElement('div', {
        className: 'col'
      }, /*#__PURE__*/React.createElement(CognitiveCard, {
        cognitiveDataMain: scores.cognitive_data.main,
        cognitiveDataScores: scores.cognitive_data.scores,
        hasProfile: !!profile_id,
        enrollment: enrollment_id
      })) : null, scores.personality_data.scores.length > 0 ? /*#__PURE__*/React.createElement('div', {
        className: 'col'
      }, /*#__PURE__*/React.createElement(PersonalityCard, {
        personalityDataMain: scores.personality_data.main,
        personalityDataScores: scores.personality_data.scores,
        hasProfile: !!profile_id,
        enrollment: enrollment_id
      })) : null));
    }
  }]);
  return EnrollmentScores;
}(Component);

export default EnrollmentScores;